import React from 'react';

export default function PlanejamentoPage() {
  return (
    <div>
      Qualidade - Planejamento (placeholder).
    </div>
  );
}

